import { render, staticRenderFns } from "./VerifiedEmail.vue?vue&type=template&id=6fabce6c&scoped=true"
import script from "./VerifiedEmail.vue?vue&type=script&lang=js"
export * from "./VerifiedEmail.vue?vue&type=script&lang=js"
import style0 from "./VerifiedEmail.vue?vue&type=style&index=0&id=6fabce6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fabce6c",
  null
  
)

export default component.exports